export function copyInputToClipboard(services, input, messages) {
  if (!navigator.clipboard) {
    if (fallbackCopyTextToClipboard(input)) {
      services.AlertingFactory.success(messages.success);
      return;
    }
    services.AlertingFactory.error('parameters/quick_replies/details/facebook_ad/copy_payload_error1');
    return;
  }
  navigator.clipboard.writeText(input).then(() => {
    services.AlertingFactory.success(messages.success);
  }, err => {
    if (navigator.userAgent.search('Firefox')) {            // Special case for Firefox (impossible to copy async text to clipboard otherwise)
      fallbackCopyTextToClipboardFirefox(services, input);
      return;
    }
    if (fallbackCopyTextToClipboard(input)) {
      services.AlertingFactory.success(messages.success);
      return;
    }
    services.AlertingFactory.error(messages.error);
    console.error('Async: Could not copy text: ', err);
  });
}

function fallbackCopyTextToClipboard(input) {
  const textArea = document.createElement('textarea')
  textArea.classList.add('fallback-copy-textarea');
  textArea.value = input;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
    return 0;
  }
  document.body.removeChild(textArea);

  return 1;
}

function fallbackCopyTextToClipboardFirefox(services, input) {
  services.$uibModal.open({
    animation: true,
    template:  require('./copyToClipboard.modal.html'),
    controller: 'copyToClipboardModalController',
      resolve: {
        controllerParams: {
          input,
          titleOfInformationPopin: services.$translate.instant('parameters/quick-replies/dropdown_link4')
        }
      }
  });
}